(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ab-featured-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ab-featured-products')) {
    customElements.define('ab-featured-products', class extends HTMLElement {
      connectedCallback() {
        this.sliders = [...this.querySelectorAll('[data-abfeatured-viewport]')]
          .map((viewport) => {
            const track = viewport.querySelector('.abfeatured__track');
            if (!track) return null;

            const state = {
              viewport,
              track,
              dragging: false,
              startX: 0,
              startScroll: 0,
              hasMoved: false
            };

            viewport.addEventListener('pointerdown', (event) => {
              if (event.pointerType === 'mouse' && event.button !== 0) return;
              state.dragging = true;
              state.hasMoved = false;
              state.startX = event.clientX;
              state.startScroll = viewport.scrollLeft;
              viewport.classList.add('is-dragging');
            });

            viewport.addEventListener('pointermove', (event) => {
              if (!state.dragging) return;
              const deltaX = event.clientX - state.startX;
              if (Math.abs(deltaX) > 5) state.hasMoved = true;
              viewport.scrollLeft = state.startScroll - deltaX;
            });

            const stopDrag = () => {
              if (!state.dragging) return;
              state.dragging = false;
              viewport.classList.remove('is-dragging');
            };

            viewport.addEventListener('pointerup', stopDrag);
            viewport.addEventListener('pointercancel', stopDrag);
            viewport.addEventListener('dragstart', (event) => event.preventDefault());

            // Drag uses the same click guard as the original slider.
            viewport.addEventListener('click', (event) => {
              if (state.hasMoved) {
                event.preventDefault();
                event.stopPropagation();
              }
            }, true);

            return state;
          })
          .filter(Boolean);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["automotivebypass-collection"] && !Shopify.designMode) return;
  try {
    
  (()=>{if(customElements.get('vehicle-collection'))return;const keys=['brand','model','year'],clean=v=>String(v??'').trim(),norm=v=>clean(v).toLocaleLowerCase(),canon=v=>{const n=norm(v).replace(/[^a-z0-9]+/g,'');return({chevy:'Chevrolet',chevrolet:'Chevrolet',gmc:'GMC',ram:'RAM'}[n]||clean(v))},esc=v=>clean(v).replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));class VehicleCollection extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;this.layout=this.querySelector('.ab-catalog__layout');this.grid=this.querySelector('[data-ab-grid]');this.nativePagination=this.querySelector('[data-ab-pagination]');this.fixedBrand=canon(this.dataset.fixedBrand);this.fixedCategory=norm(this.dataset.fixedCategory);this.selection={brand:new Set,model:new Set,year:new Set};this.labels={brand:new Map,model:new Map,year:new Map};this.currentPage=1;this.perPage=20;this.catalogUrl=this.dataset.catalogUrl||'';this.catalog=new Map;this.readUrl();this.bindStatic();this.setupDescription();this.loadAll()}disconnectedCallback(){if(this.popHandler)removeEventListener('popstate',this.popHandler)}bindStatic(){this.querySelector('[data-ab-sort]')?.addEventListener('change',e=>{const u=new URL(location.href);u.searchParams.set('sort_by',e.target.value);u.searchParams.delete('page');location.assign(u)});this.querySelector('[data-ab-clear]')?.addEventListener('click',()=>this.clear());this.querySelector('[data-ab-empty-clear]')?.addEventListener('click',()=>this.clear());this.querySelector('[data-ab-finder-form]')?.addEventListener('submit',e=>this.submitFinder(e));this.addEventListener('change',e=>{const i=e.target.closest('input[data-ab-key]');if(!i)return;i.checked?this.selection[i.dataset.abKey].add(i.value):this.selection[i.dataset.abKey].delete(i.value);this.currentPage=1;this.render(true)});this.popHandler=()=>{this.readUrl();this.render(false)};addEventListener('popstate',this.popHandler)}setupDescription(){const d=this.querySelector('[data-ab-description]'),b=this.querySelector('[data-ab-description-toggle]');if(!d||!b)return;requestAnimationFrame(()=>{if(d.scrollHeight>d.clientHeight+3){d.classList.add('is-overflowing');b.hidden=false}});b.addEventListener('click',()=>{const open=d.classList.toggle('is-expanded');d.classList.toggle('is-overflowing',!open);b.setAttribute('aria-expanded',String(open));b.querySelector('[data-ab-read-more]').hidden=open;b.querySelector('[data-ab-read-less]').hidden=!open})}parse(card){const raw=this.catalog.get(card.dataset.productHandle)||'[]';const category=norm(card.dataset.productCategory);const brands=(card.dataset.productBrands||'').split(',').map(norm).filter(Boolean);const inScope=(!this.fixedCategory||category===this.fixedCategory)&&(!this.fixedBrand||brands.includes('vehicle-brand:'+norm(this.fixedBrand)));const parsed=inScope?(window.ABFitment?ABFitment.parse(raw):[]):[];const rows=parsed.flatMap(r=>{const brand=canon(r.make||r.Make),model=clean(r.model||r.Model),year=clean(r.year||r.Year),years=window.ABFitment?ABFitment.expandYears(year):[year];return years.map(y=>({brand,model,year:y}))}).filter(r=>r.brand&&r.model&&r.year).map(r=>{keys.forEach(k=>{const n=norm(r[k]);if(!this.labels[k].has(n))this.labels[k].set(n,r[k])});return Object.fromEntries(keys.map(k=>[k,norm(r[k])]))});return{card,rows,category,brands}}async loadCatalog(){if(!this.catalogUrl)return;try{const r=await fetch(this.catalogUrl,{credentials:'same-origin'});if(!r.ok)throw Error('catalog');const data=await r.json();this.catalog=new Map((data.products||[]).map(product=>[product.handle,product.fitment||'[]']))}catch(e){this.catalog=new Map}}async loadAll(){this.setAttribute('aria-busy','true');const serverPage=Number(this.layout.dataset.serverPage)||1,total=Number(this.layout.dataset.totalPages)||1,groups=new Map([[serverPage,[...this.grid.querySelectorAll(':scope > [data-ab-card]')]]]);try{await this.loadCatalog();const requests=[];for(let page=1;page<=total;page+=1){if(page===serverPage)continue;requests.push(this.fetchPage(page).then(cards=>groups.set(page,cards)))}await Promise.all(requests);const seen=new Set;this.items=[...groups.entries()].sort((a,b)=>a[0]-b[0]).flatMap(x=>x[1]).filter(card=>{const id=card.dataset.productId;if(seen.has(id))return false;seen.add(id);return true}).map(card=>this.parse(card));this.nativePagination.replaceChildren();this.populateFinder();this.render(false)}catch(e){const n=this.querySelector('[data-ab-error]');n.hidden=false;n.textContent=this.dataset.loadError;this.querySelector('[data-ab-loading]').hidden=true}finally{this.removeAttribute('aria-busy')}}async fetchPage(page){const u=new URL(location.href);u.searchParams.set('section_id',this.dataset.sectionId);u.searchParams.set('page',String(page));keys.forEach(k=>u.searchParams.delete('vehicle_'+k));const r=await fetch(u,{headers:{'X-Requested-With':'XMLHttpRequest'}});if(!r.ok)throw Error('request');const doc=new DOMParser().parseFromString(await r.text(),'text/html'),root=doc.querySelector('vehicle-collection');if(!root)throw Error('section');return[...root.querySelectorAll('[data-ab-grid] > [data-ab-card]')]}readUrl(){const p=new URLSearchParams(location.search);keys.forEach(k=>{this.selection[k]=new Set((p.get('vehicle_'+k)||'').split(',').map(norm).filter(Boolean))});if(this.fixedBrand)this.selection.brand=new Set([norm(this.fixedBrand)]);this.currentPage=Math.max(1,Number(p.get('catalog_page'))||1)}writeUrl(){const u=new URL(location.href);keys.forEach(k=>{if(k==='brand'&&this.fixedBrand){u.searchParams.delete('vehicle_brand');return}const values=[...this.selection[k]];values.length?u.searchParams.set('vehicle_'+k,values.join(',')):u.searchParams.delete('vehicle_'+k)});this.currentPage>1?u.searchParams.set('catalog_page',String(this.currentPage)):u.searchParams.delete('catalog_page');u.searchParams.delete('page');history.pushState({},'',u)}matchesRow(row,skip=''){return keys.every(k=>k===skip||this.selection[k].size===0||this.selection[k].has(row[k]))}matchesItem(item){if(this.fixedCategory&&(!item.category||item.category!==this.fixedCategory))return false;if(this.fixedBrand&&(!item.brands.includes('vehicle-brand:'+norm(this.fixedBrand))||!item.rows.length))return false;const active=keys.filter(k=>!(k==='brand'&&this.fixedBrand)&&this.selection[k].size>0);if(!item.rows.length)return active.length===0;return item.rows.some(r=>this.matchesRow(r))}available(key){const map=new Map;this.items.forEach(item=>{const values=new Set;item.rows.forEach(row=>{if(this.matchesRow(row,key))values.add(row[key])});values.forEach(value=>map.set(value,(map.get(value)||0)+1))});return map}buildOptions(){keys.forEach(key=>{if(key==='brand'&&this.fixedBrand)return;const root=this.querySelector('[data-ab-options="'+key+'"]');if(!root)return;const counts=this.available(key),values=[...this.labels[key].keys()].sort((a,b)=>this.sortValue(key,a,b));root.innerHTML=values.map(value=>{const count=counts.get(value)||0,checked=this.selection[key].has(value);return'<label class="ab-catalog__option"><input type="checkbox" data-ab-key="'+key+'" value="'+esc(value)+'" '+(checked?'checked ':'')+(count?'':'disabled ')+'><span>'+esc(this.labels[key].get(value))+'</span><small>'+count+'</small></label>'}).join('')})}sortValue(key,a,b){const av=this.labels[key].get(a),bv=this.labels[key].get(b);if(key==='year')return Number(bv)-Number(av);return av.localeCompare(bv)}populateFinder(){const brand=this.querySelector('[data-ab-finder-brand]'),model=this.querySelector('[data-ab-finder-model]'),year=this.querySelector('[data-ab-finder-year]'),submit=this.querySelector('[data-ab-finder-submit]');if(brand){this.fillSelect(brand,[...this.labels.brand.values()].sort((a,b)=>a.localeCompare(b)),brand.options[0].text);brand.disabled=false;brand.addEventListener('change',()=>{this.populateFinderModels();submit.disabled=true})}this.populateFinderModels();model.addEventListener('change',()=>{this.populateFinderYears();submit.disabled=true});year.addEventListener('change',()=>{submit.disabled=!year.value})}finderBrand(){return this.fixedBrand||this.querySelector('[data-ab-finder-brand]')?.value||''}populateFinderModels(){const model=this.querySelector('[data-ab-finder-model]'),year=this.querySelector('[data-ab-finder-year]'),brand=norm(this.finderBrand()),values=new Map;this.items.forEach(item=>item.rows.forEach(row=>{if(!brand||row.brand===brand)values.set(row.model,this.labels.model.get(row.model))}));this.fillSelect(model,[...values.values()].sort((a,b)=>a.localeCompare(b)),model.options[0]?.text||'');model.disabled=!brand;this.fillSelect(year,[],year.options[0]?.text||'');year.disabled=true}populateFinderYears(){const year=this.querySelector('[data-ab-finder-year]'),brand=norm(this.finderBrand()),model=norm(this.querySelector('[data-ab-finder-model]').value),values=new Map;this.items.forEach(item=>item.rows.forEach(row=>{if(row.brand===brand&&row.model===model)values.set(row.year,this.labels.year.get(row.year))}));this.fillSelect(year,[...values.values()].sort((a,b)=>Number(b)-Number(a)),year.options[0]?.text||'');year.disabled=!model}fillSelect(select,values,label){select.replaceChildren(new Option(label,''));values.forEach(v=>select.add(new Option(v,v)))}submitFinder(e){e.preventDefault();const brand=this.finderBrand(),model=this.querySelector('[data-ab-finder-model]').value,year=this.querySelector('[data-ab-finder-year]').value;if(!brand||!model||!year)return;this.selection.brand=new Set([norm(brand)]);this.selection.model=new Set([norm(model)]);this.selection.year=new Set([norm(year)]);this.currentPage=1;this.render(true);this.querySelector('.ab-catalog__layout').scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'})}clear(){keys.forEach(k=>this.selection[k].clear());if(this.fixedBrand)this.selection.brand.add(norm(this.fixedBrand));this.currentPage=1;this.render(true)}render(push){if(!this.items)return;const filtered=this.items.filter(item=>this.matchesItem(item)),pages=Math.max(1,Math.ceil(filtered.length/this.perPage));this.currentPage=Math.min(this.currentPage,pages);const start=(this.currentPage-1)*this.perPage,end=start+this.perPage;this.grid.replaceChildren(...filtered.slice(start,end).map(x=>x.card));this.grid.hidden=filtered.length===0;this.querySelector('[data-ab-empty]').hidden=filtered.length>0;const template=filtered.length===1?this.dataset.countOne:this.dataset.countOther;this.querySelector('[data-ab-count]').textContent=template.replace('__count__',String(filtered.length));this.querySelector('[data-ab-loading]').hidden=true;this.buildOptions();this.renderSelected();this.renderPagination(pages);this.querySelector('[data-ab-clear]').disabled=!keys.some(k=>k!=='brand'||!this.fixedBrand?[...this.selection[k]].length:false);if(push)this.writeUrl()}renderSelected(){const root=this.querySelector('[data-ab-selected]'),nodes=[];keys.forEach(key=>{if(key==='brand'&&this.fixedBrand)return;this.selection[key].forEach(value=>{const b=document.createElement('button');b.type='button';b.textContent=(this.labels[key].get(value)||value)+' ×';b.addEventListener('click',()=>{this.selection[key].delete(value);this.currentPage=1;this.render(true)});nodes.push(b)})});root.replaceChildren(...nodes)}renderPagination(pages){const root=this.nativePagination;if(pages<=1){root.replaceChildren();return}const nodes=[];for(let p=1;p<=pages;p+=1){const b=document.createElement('button');b.type='button';b.textContent=String(p);b.setAttribute('aria-label',this.dataset.pageLabel.replace('__page__',String(p)));if(p===this.currentPage){b.className='is-current';b.setAttribute('aria-current','page')}b.addEventListener('click',()=>{this.currentPage=p;this.render(true);this.grid.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'})});nodes.push(b)}root.replaceChildren(...nodes)}}customElements.define('vehicle-collection',VehicleCollection)})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["automotivebypass-footer"]) return;
  try {
    
/**
 * AutomotiveBypass Footer
 * >= 750px : all columns forced open, summary not clickable / not focusable
 * <  750px : columns collapsed by default (accordion)
 * Markup renders every <details> with `open`, so content stays visible if JS fails.
 */
(function () {
  if (window.__abpFooterLoaded) return;
  window.__abpFooterLoaded = true;

  var mq = window.matchMedia('(min-width: 750px)');

  function sync(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var isDesktop = mq.matches;

    scope.querySelectorAll('[data-abp-footer-details]').forEach(function (details) {
      var summary = details.querySelector('[data-abp-footer-summary]');

      if (isDesktop) {
        details.setAttribute('open', '');
        if (summary) summary.setAttribute('tabindex', '-1');
      } else {
        details.removeAttribute('open');
        if (summary) summary.removeAttribute('tabindex');
      }
    });
  }

  // Block toggling on desktop (single delegated listener)
  document.addEventListener('click', function (event) {
    if (!mq.matches) return;
    var summary = event.target.closest && event.target.closest('[data-abp-footer-summary]');
    if (summary) event.preventDefault();
  });

  // Breakpoint changes (resize / rotate)
  if (mq.addEventListener) {
    mq.addEventListener('change', function () { sync(); });
  } else if (mq.addListener) {
    mq.addListener(function () { sync(); });
  }

  // Theme editor: section re-rendered
  document.addEventListener('shopify:section:load', function (event) {
    sync(event.target);
  });

  // Initial run (script may execute before the DOM is parsed)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { sync(); });
  } else {
    sync();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
